import { Button, Modal } from "@mantine/core";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { ModalFooter } from "../../../../mantine/components/ModalFooter/ModalFooter";
import { useParagraph6CancellationMutations } from "../../hooks/useParagraph6CancellationMutations";

export interface Paragraph6ConfirmCancellationModalProps {
  creditId?: string;
  variantId: number;
  onClose: () => void;
}

function Paragraph6ConfirmCancellationModal({
  creditId,
  variantId,
  onClose
}: Paragraph6ConfirmCancellationModalProps) {
  const queryClient = useQueryClient();
  const [submitting, setSubmitting] = useState(false);
  const { paragraph6CancellationCreateMutation } =
    useParagraph6CancellationMutations(variantId);

  function onConfirm() {
    if (!creditId) return;

    setSubmitting(true);

    paragraph6CancellationCreateMutation.mutate(creditId, {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["paragraph6Credits", { variantId }]
        });
      },
      onSettled: () => {
        setSubmitting(false);
        onClose();
      }
    });
  }
  return (
    <Modal
      opened={!!creditId}
      title="Wollen Sie diese Gutschrift stornieren?"
      onClose={onClose}
    >
      <p>
        Wenn Sie diese Gutschrift stornieren, erstellt opti.node automatisch
        einen Stornobeleg für Sie.
        <br />
        Der Status der Gutschrift kann anschließend nicht mehr verändert werden.
      </p>
      <ModalFooter>
        <Button variant="default" onClick={onClose}>
          Abbrechen
        </Button>
        <Button color="error" loading={submitting} onClick={onConfirm}>
          Ja, stornieren
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { Paragraph6ConfirmCancellationModal };
